export default __webpack_public_path__ + "static/media/Banners_Diadelpadre_amazon_330x330.c7bd74d6.jpg";